import React from "react";
import MuiDialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "./dialogTitle";

const SlidesContainer = ({ slides, currentSlide, classes, handleToggleDrawer }) => {
  return (
    <>
      <DialogTitle
        title={slides[currentSlide].header}
        classes={classes}
        onClose={handleToggleDrawer}
        type={slides[currentSlide].type}
      />
      <MuiDialogContent
        classes={{
          root: classes.container,
        }}
      >
        {slides[currentSlide].slide}
      </MuiDialogContent>
    </>
  );
};

export default SlidesContainer;